import { render, staticRenderFns } from "./TipoDocumentoCombobox.vue?vue&type=template&id=755a6674&scoped=true"
import script from "./TipoDocumentoCombobox.vue?vue&type=script&lang=js"
export * from "./TipoDocumentoCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a6674",
  null
  
)

export default component.exports